import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { map, take } from "rxjs/operators";
import { EnvironmentService } from "./environment.service";

@Injectable({
  providedIn: "root",
})
export class RouteGuardService  {
  constructor(
    public environmentService: EnvironmentService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const result = new BehaviorSubject(true);

    this.environmentService.getInstanceDetails().pipe(
      take(1),
      map((details: any) => {
        if(Array.isArray(route?.data?.toMatch)&&route?.data?.toMatch.find(match=>match.test(details?.scaffoldType))){
          return result.next(true);
        }
        if (route?.data?.toMatch?.test&& route?.data?.toMatch?.test(details?.scaffoldType)) {
          result.next(true);
        } else {
          this.router.navigate(["/home"]);
          result.next(false);
        }
      })
    ).subscribe()
    return result;
  }
}
